import React from 'react';
import { Modal, List, Input, Button, Popconfirm, Typography, notification } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

import request from '../lib/request';

/** Checklist template of one Service Task - copied onto every task generated from it. */
export default function ChecklistTemplateModal({ task, onClose }) {
  const [items, setItems] = React.useState([]);
  const [title, setTitle] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!task) return;
    setLoading(true);
    request
      .get(`/services/tasks/${task.id}/checklist`)
      .then((r) => r.json())
      .then((r) => {
        if (r.status) setItems(r.data);
        else notification.error({ message: r.message });
      })
      .finally(() => setLoading(false));
  }, [task]);

  const apply = (r) => {
    if (r.status) setItems(r.data);
    else notification.error({ message: r.message });
  };
  const add = () => {
    if (!title.trim()) return;
    request
      .post(`/services/tasks/${task.id}/checklist`, { title: title.trim() })
      .then((r) => r.json())
      .then((r) => {
        apply(r);
        if (r.status) setTitle('');
      });
  };
  const remove = (item) => request.delete(`/services/tasks/${task.id}/checklist/${item.id}`).then((r) => r.json()).then(apply);

  return (
    <Modal title={task ? `Checklist template - ${task.task_name}` : ''} open={!!task} onCancel={onClose} footer={null} destroyOnClose>
      <Typography.Paragraph type="secondary">These steps are copied onto every task generated from this service task; staff tick them off on the task itself.</Typography.Paragraph>
      <List
        size="small"
        loading={loading}
        dataSource={items}
        locale={{ emptyText: 'No template items yet' }}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <Popconfirm key="del" title="Remove this step?" onConfirm={() => remove(item)}>
                <Button type="text" size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>,
            ]}
          >
            {index + 1}. {item.title}
          </List.Item>
        )}
      />
      <Input.Group compact style={{ marginTop: 8, display: 'flex' }}>
        <Input placeholder="Add a step" value={title} onChange={(e) => setTitle(e.target.value)} onPressEnter={add} maxLength={255} />
        <Button icon={<PlusOutlined />} onClick={add}>
          Add
        </Button>
      </Input.Group>
    </Modal>
  );
}
